import { Controller } from "stimulus";
import Tooltip from 'tooltip.js';

export default class extends Controller {

  connect() {
    if (this.activeDropDownItem) {
      this.activeDropDownMenu.style.display = "block"
      this.activeDropDown.classList.add("active")
    }
    $('[data-toggle="tooltip"]').tooltip({
      html: true // 允许使用 HTML
    });
  }

  // Private

  get activeDropDownItem() {
    return this.element.querySelector(".dropdown-menu > li.active")
  }

  get activeDropDownMenu() {
    return this.activeDropDownItem.closest(".dropdown-menu")
  }

  get activeDropDown() {
    return this.activeDropDownItem.closest(".dropdown")
  }

}
